//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Button, Typography } from "antd";

import { FC, useEffect, useState } from "react";
import dayjs from "dayjs";
import TableProductList from "./TableProductList";
import { DataOrderproductskuNewOrder } from "services/interface";
interface FinishOrderTableProps {
  data: DataOrderproductskuNewOrder | undefined;
  limit: number;
  setLimit: (limit: number) => void;
  offset: number;
  setOffset: (offset: number) => void;
  isLoading: boolean;
}

const FinishOrderTable: FC<FinishOrderTableProps> = ({data, limit, setLimit, offset, setOffset, isLoading}) => {
  return (
    <>
      <CardWrapperTable>
        <TableProductList data={data} limit={limit} setLimit={setLimit} offset={offset} setOffset={setOffset} isLoading={isLoading} /> 
      </CardWrapperTable>
    </>
  );
};

export default FinishOrderTable;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 15px;
`;
